function RiraLogo({
  size = 32,
  nameColor,
  showTagline = false,
  taglineColor,
  layout = "horizontal",
  nameFontSize,
}) {
  const isVertical = layout === "vertical";
  const hasTaglineRow = showTagline && !isVertical;

  return (
    <div
      className="rira-logo"
      style={{
        display: "flex",
        flexDirection: isVertical ? "column" : "row",
        alignItems: isVertical ? "center" : (hasTaglineRow ? "flex-start" : "center"),
        gap: isVertical ? 10 : 9,
        textDecoration: "none",
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        style={{ flexShrink: 0, marginTop: hasTaglineRow ? 1 : 0 }}
      >
        <rect width="36" height="36" rx="9" fill="#1A1A1A" />
        <polyline
          points="6,27 12,17 19,22 28,10"
          stroke="white"
          strokeWidth="2.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="28" cy="10" r="2.8" fill="white" />
      </svg>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: isVertical ? 4 : 2,
          alignItems: isVertical ? "center" : "flex-start",
          textAlign: isVertical ? "center" : "left",
        }}
      >
        <span
          className="rira-logo-name"
          style={{
            ...(nameColor ? { color: nameColor } : {}),
            fontSize: nameFontSize || (isVertical ? "1.5rem" : "1.1rem"),
            fontWeight: 800,
            letterSpacing: "-0.3px",
            lineHeight: 1,
            fontFamily: "inherit",
          }}
        >
          Rira
        </span>
        {showTagline && (
          <span
            className="rira-logo-tagline"
            style={{
              ...(taglineColor ? { color: taglineColor } : {}),
              fontSize: "0.65rem",
              fontWeight: 500,
              letterSpacing: "0.15px",
              lineHeight: 1.3,
              opacity: 0.65,
              fontFamily: "inherit",
              maxWidth: isVertical ? 200 : "none",
              textAlign: isVertical ? "center" : "left",
            }}
          >
            {isVertical ? <>Review Intelligence<br />Response Assistant</> : "Review Intelligence Response Assistant"}
          </span>
        )}
      </div>
    </div>
  );
}

export default RiraLogo;
